import { useState } from 'react';
import { LayoutChangeEvent } from 'react-native';

interface UseDimensionsProps {
  initialWidth?: number;
  initialHeight?: number;
}

export const useDimensions = ({ initialWidth = 0, initialHeight = 0 }: UseDimensionsProps) => {
  const [dimensions, setDimensions] = useState({ width: initialWidth, height: initialHeight });
  const onLayout = (event: LayoutChangeEvent) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  };

  return { dimensions, onLayout };
};
